type EventCallback<T = unknown> = (data: T) => void;

export class EventBus {
  private listeners = new Map<string, Set<EventCallback>>();

  on<T = unknown>(event: string, callback: EventCallback<T>): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback as EventCallback);

    return () => {
      this.listeners.get(event)?.delete(callback as EventCallback);
    };
  }

  emit<T = unknown>(event: string, data?: T): void {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      for (const cb of callbacks) {
        cb(data);
      }
    }
  }

  off(event: string, callback: EventCallback): void {
    this.listeners.get(event)?.delete(callback);
  }

  clear(): void {
    this.listeners.clear();
  }
}

// Global event bus instance
export const gameEvents = new EventBus();

// Event types
export const Events = {
  // Game
  GAME_PAUSE: 'game:pause',
  GAME_RESUME: 'game:resume',
  GAME_OVER: 'game:over',
  LEVEL_COMPLETE: 'level:complete',

  // Player
  PLAYER_DEATH: 'player:death',
  PLAYER_DAMAGE: 'player:damage',
  PLAYER_COLLECT: 'player:collect',

  // Combat
  SHOT_FIRED: 'combat:shot',
  ENEMY_KILLED: 'combat:enemy_killed',
  NOISE_CREATED: 'combat:noise',

  // UI
  UI_SCORE_CHANGED: 'ui:score',
  UI_LIVES_CHANGED: 'ui:lives',
  UI_AMMO_CHANGED: 'ui:ammo',
} as const;
